<template>
  <div class="menu bg-light border-right">
    <nav class="navbar-expand-xl">
      <div class="collapse navbar-collapse w-100" id="navbarSupportedContent">
        <ul>
          <template v-for="opcion in menu">
            <li v-if="opcion.path" :key="opcion.nombre">
              <router-link :to="opcion.path" class="text-dark" :class="{ 'active': opcion.active}"  @click.native="toggleMenu(opcion)">
                <font-awesome-icon :icon="opcion.icono" class="text-primary-dark" /> {{ opcion.nombre}}
              </router-link>
            </li>
            <li v-else :key="opcion.nombre" :class="{ 'dropup': opcion.active }">
              <a href="javascript:void(0)" @click="toggleMenu(opcion)" class="text-dark dropdown-toggle" :class="{ 'active': opcion.active}">
                <font-awesome-icon :icon="opcion.icono" class="text-primary-dark" /> {{ opcion.nombre}}
              </a>
              <ul class="submenu" :class="{ 'collapse': !opcion.active }">
                <li v-for="subopcion in opcion.submenu" :key="subopcion.nombre">
                  <router-link :to="subopcion.path" class="text-dark">{{ subopcion.nombre}}</router-link>
                </li>  
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'side-bar',
  data() {
    return {
      menu: [
        {
          nombre: 'Inicio',
          path: '/',
          active: true,
          icono: 'home',
          submenu: []
        },
        {
          nombre: 'Mis seguros',
          path: '/polizas',
          active: false,
          icono: 'folder-open',
          submenu: []
        },
        {
          nombre: 'Mis recibos',
          path: '/recibos',
          active: false,
          icono: 'euro-sign',
          submenu: []
        },
        {
          nombre: 'Mis siniestros',
          path: '/siniestros',
          active: false,
          icono: 'exclamation-triangle',
          submenu: []
        },
        {
          nombre: 'Mis proyectos',
          path: '/proyectos',
          active: false,
          icono: 'briefcase',
          submenu: []
        },
        {
          nombre: 'Teléfonos asistencia',
          path: '/telefonos-asistencia',
          active: false,
          icono: 'phone',
          submenu: []
        },
        {
          nombre: 'Mis datos',
          path: '/yo',
          active: false,
          icono: 'user',
          submenu: []
        },
      ]
    }
  },
  methods: {
    toggleMenu(opcion) {
      for(let i = 0; i < this.menu.length; i++) {
        if (opcion.nombre != this.menu[i].nombre) {
          this.menu[i].active = false
        } else {
          this.menu[i].active = !this.menu[i].active;
        }
      }
    }
  }
}
</script>
<style>
.menu > nav > div > ul {
    list-style-type: none;
    margin: 0;
    padding: 53px 0 0 0;
    width: 100%;
}
.menu > nav > div > ul > li > a {
  line-height: 42px;
  border-bottom: 1px solid #dee2e6;
  display: block;
  width: 100%;
  padding-left: 10px;
}
.menu > nav > div > ul > li > a.active {
  background-color: #ededed;
}
.menu > nav > div > ul > li > a:hover {
  text-decoration: none;
  background-color: #ededed;
}
.menu svg {
  min-width: 20px;
  display: inline-block;
  vertical-align: -2px!important;
}
.submenu {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.submenu > li > a {
  border-bottom: 1px solid #dee2e6;
  display: block;
  width: 100%;
  padding-left: 40px;
  font-size: 0.9rem;
  line-height: 34px;
  background-color: #ededed;
}
.menu > nav > div > ul > li > a.dropdown-toggle::after {
  float: right;
  margin-top: 16px!important;
  margin-right: 10px;
  color: #bbb;
}
@media (min-width: 1200px) {
  .menu {
    height: 100vh; 
    width: 300px;
    margin-top: -53px;
    overflow: auto;
  }
}
@media (max-width: 1200px) {
  .menu {
    position: absolute;
    width: 100%;
    z-index: 1000;
    margin-top: -53px;
  }
}
@media (max-width: 768px) {
  .menu > nav > div > ul > li > a, .submenu > li > a {
    line-height: 40px!important;
  }
  .menu > nav > div > ul {
    padding-top: 0;
    padding-bottom: 10px;
  }
  .menu {
    margin-top: 0;
  }
}
</style>

